import Calendar from "@/components/Page__Home/Calendar";
import Head from "next/head";
import Layout from "@/components/Layouts/Layout";
import Tagline from "@/components/Page__Home/Tagline";
import { client } from "../../config/sanity";

export interface Homepage {
  tagline: Tagline;
  quote: string;
  marquee: {
    text: string;
    link: {
      slug: {
        current: string;
      };
    };
  };
  calendar: CalendarProps;
  navBlock: {
    navImage: {
      asset: {
        metadata: {
          lqip: string;
        };
      };
    };
  };
}

export default function Home({
  homepage,
  settings,
  headerMenu,
}: {
  homepage: Homepage;
  settings: SettingsProps;
  headerMenu: Page[];
}) {
  return (
    <>
      <Head>
        <title>Allesbien Festival</title>
        <meta
          name="description"
          content="Allesbien Festival: A celebration of art, music, and community. Join us for events, support, and more."
        />
      </Head>
      <Layout
        pages={headerMenu}
        settings={settings}
        quote={homepage.quote}
        home={homepage.navBlock}
      >
        <Tagline tagline={homepage.tagline} />
        <div id="events">
          <script src="https://elfsightcdn.com/platform.js" async></script>
          <div
            className="elfsight-app-217d180a-59b8-45f3-ba0d-3e251d31f0c6"
            data-elfsight-app-lazy
          ></div>
        </div>
        {/* <Calendar calendar={homepage.calendar} email={settings.email} /> */}
      </Layout>
    </>
  );
}

export const getStaticProps = async () => {
  try {
    const homepage = await client.fetch(
      '*[_type == "homepage" && !(_id in path("drafts.**"))]{..., calendar {..., events[]{..., saveTheDate, figure{..., image{..., asset->{..., metadata{lqip}}}}, category->}}, navBlock{...,navImage{..., asset->{..., metadata{lqip}}}}, marquee{...,link->}, tagline{..., figure{...,image{..., asset->{..., metadata{lqip}}}}, callToActions{callToAction1->, callToAction2->}}}[0]',
    );
    const pages = await client.fetch(
      '*[_type == "page" && !(_id in path("drafts.**"))]{..., navBlock{...,navImage{..., asset->{..., metadata{lqip}}}}}',
    );

    const settings = await client.fetch(
      '*[_type == "settings" && !(_id in path("drafts.**"))]{..., marquee{..., link->}}[0]',
    );

    const headerMenu: any[] = await client.fetch(
      '*[_type == "menus"][0].headerMenu[]->{name, slug, navBlock{navImage{asset->{...,metada{lqip}}}}}',
    );
    const countdown: any[] = await client.fetch(
      '*[_id == "0359db94-2064-4aee-99a8-083512eb2030"][0]{countdown}',
    );

    if (!pages) {
      return { notFound: true };
    }

    return {
      props: {
        pages,
        homepage,
        settings,
        headerMenu,
        countdown,
      },
      revalidate: 10,
    };
  } catch (error) {
    console.error("Error fetching data:", error);
    return {
      props: {
        page: null,
      },
      revalidate: 10,
    };
  }
};
